var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCnPaymentVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Visa-dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130 -164) translate(130 164)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 60,
    fill: "#26337A",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M41.5 39.55l3.06-19.08h4.92L46.4 39.55h-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M64.23 20.94c-.97-.38-2.5-.8-4.4-.8-4.86 0-8.28 2.6-8.3 6.3-.04 2.74 2.43 4.27 4.3 5.18 1.9.93 2.55 1.53 2.55 2.36-.02 1.28-1.53 1.87-2.95 1.87-1.96 0-3-.3-4.63-1l-.63-.3-.68 4.26c1.13.54 3.26 1 5.46 1.03 5.17 0 8.52-2.56 8.56-6.52.02-2.16-1.3-3.8-4.13-5.17-1.73-.88-2.78-1.47-2.77-2.36 0-.8.9-1.65 2.82-1.65 1.6-.02 2.77.35 3.68.74l.44.22.66-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M70.78 32.78c.4-1.1 1.96-5.33 1.96-5.33-.03.05.4-1.1.65-1.82l.32 1.65s.94 4.55 1.14 5.5h-4.08zm6.06-12.3h-3.8c-1.18 0-2.06.35-2.57 1.6l-7.3 17.47h5.16s.84-2.35 1.03-2.86c.57 0 5.58 0 6.3 0 .15.66.6 2.85.6 2.85h4.56L76.84 20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M37.37 20.5l-4.8 13-.53-2.65c-.9-3.05-3.7-6.35-6.8-8l4.4 16.68h5.2l7.74-19.04h-5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC982D",
    d: "M28.1 20.48h-7.94l-.06.4c6.17 1.57 10.25 5.38 11.94 9.97l-1.72-8.76c-.3-1.22-1.16-1.58-2.23-1.62"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnPaymentVisa);
export default __webpack_public_path__ + "static/media/cn-payment-visa.81287f48ab35b7ae6ede708aa6e68500.svg";
export { ForwardRef as ReactComponent };